import React, { useEffect, useState, useContext } from "react"
import { ROUTE_PATHS } from "../utils/routes"
import { Link } from "react-router-dom"
import { ErrorMessage } from "./styled"
import { OfferApi } from "../utils/api"
import { AppContext } from "./context/AppContext"
import PropTypes from "prop-types"
import AnalyticsService from "../utils/AnalyticsService"

const KEEP_AND_SWITCH_OFFER_ID = 111692
const CARRIER_FREEDOM_OFFER_ID = 111694
const HINT_FREEDOM_OFFER_ID = 268636
const DIGITAL_REDIRECT_ASSET = "DIGITAL_REDIRECT"

const getDigitalRedirectBase = async (offerId) => {
    try {
        const asset = await OfferApi.getOfferAsset(offerId, DIGITAL_REDIRECT_ASSET)
        const redirectBase = asset?.notes?.trim()
        return redirectBase || null
    } catch {
        return null
    }
}

const buildLegacySwitch2Href = (baseUrl, statePrefix, offerId, phoneNumber) =>
    `${baseUrl}${statePrefix}${offerId}-${phoneNumber}`

const buildOfferRedirectHref = (digitalRedirectUrl, fallbackBaseUrl, statePrefix, offerId, phoneNumber) =>
    digitalRedirectUrl || buildLegacySwitch2Href(fallbackBaseUrl, statePrefix, offerId, phoneNumber)

export const FrontDoorOffersSection = ({ offerList, history, transactionChannel, inputPhoneNumber, isTfbOrBau }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [keepAndSwitchRedirectBase, setKeepAndSwitchRedirectBase] = useState(null);
    const [carrierFreedomRedirectBase, setCarrierFreedomRedirectBase] = useState(null);
    const { dispatch, state } = useContext(AppContext);
    const switch2Url = process.env.REACT_APP_SWITCH2_URL;
    const samsclub = 240003
    const costco = 240150

    const keepAndSwithOffer = offerList.map(offer => offer.offerId).indexOf(KEEP_AND_SWITCH_OFFER_ID) > -1 ? offerList.filter(offer => offer.offerId === KEEP_AND_SWITCH_OFFER_ID)[0] : null;
    const cfOffer = offerList.map(offer => offer.offerId).indexOf(CARRIER_FREEDOM_OFFER_ID) > -1 ? offerList.filter(offer => offer.offerId === CARRIER_FREEDOM_OFFER_ID)[0] : null;
    const hintOffer = offerList.map(offer => offer.offerId).indexOf(HINT_FREEDOM_OFFER_ID) > -1 ? offerList.filter(offer => offer.offerId === HINT_FREEDOM_OFFER_ID)[0] : null
    const promoOffers = offerList.filter(offer => offer.offerId !== KEEP_AND_SWITCH_OFFER_ID && offer.offerId !== CARRIER_FREEDOM_OFFER_ID && offer.offerId !== HINT_FREEDOM_OFFER_ID);

    useEffect(() => {
        let cancelled = false

        const loadDigitalRedirectBases = async () => {
            const hasKeepAndSwitch = offerList?.some((offer) => offer.offerId === KEEP_AND_SWITCH_OFFER_ID)
            const hasCarrierFreedom = offerList?.some((offer) => offer.offerId === CARRIER_FREEDOM_OFFER_ID)
            const requests = []

            if (hasKeepAndSwitch) {
                requests.push(
                    getDigitalRedirectBase(KEEP_AND_SWITCH_OFFER_ID).then((base) => ({ type: "ks", base }))
                )
            }
            if (hasCarrierFreedom) {
                requests.push(
                    getDigitalRedirectBase(CARRIER_FREEDOM_OFFER_ID).then((base) => ({ type: "cf", base }))
                )
            }

            if (requests.length === 0) {
                if (!cancelled) {
                    setIsLoading(false)
                }
                return
            }

            const results = await Promise.all(requests)
            if (cancelled) {
                return
            }

            results.forEach(({ type, base }) => {
                if (type === "ks") {
                    setKeepAndSwitchRedirectBase(base)
                }
                if (type === "cf") {
                    setCarrierFreedomRedirectBase(base)
                }
            })
            setIsLoading(false)
        }

        loadDigitalRedirectBases()

        return () => {
            cancelled = true
        }
    }, [offerList])

    const setCampaign = async (promoCode) => {
        try {
            dispatch({ type: "SETPROMOCODE", payload: promoCode });
            dispatch({ type: "SETSELECTEDPHONE", payload: inputPhoneNumber });
            let lookupValues = {
                phoneNumber: inputPhoneNumber,
                promoCode: promoCode,
                validateLine: true,
                userInfo: state.user.userInfo
            };
            dispatch({ type: "SETLOOKUPVALUES", payload: lookupValues });
            AnalyticsService.sendGa4Event({ event: 'Promotions', trigger: "submitted", category: promoCode, action: isTfbOrBau, label: "link_offer" })
            await OfferApi.getOfferDetails(lookupValues).then((response) => {
                if (response.redirectUrl) {
                    window.location.href = response.redirectUrl;
                    return;
                }
                if (!response.offerId && response.ineligibleReason) {
                    setErrorMessage(response.ineligibleReason);
                    setIsSubmitting(false);
                }
                else {
                    dispatch({ type: "SETCAMPAIGN", payload: response });
                    history.push(ROUTE_PATHS.PROMOTION);
                }
            },
                (error) => {
                    setErrorMessage("Something went wrong, please try again");
                    setIsSubmitting(false);
                })
        }
        catch (error) {
            setErrorMessage("Something went wrong, please try again");
            setIsSubmitting(false);
        }
    }

    return (
        !isLoading &&
        <>
            <div className="offerSection">
                <h3 className="font-weight-bold">Congratulations! Here are the promotions you <u>may</u> qualify for. <strong className="magenta">Please select one to continue: </strong></h3>
                <p >Remember, you can only select <span className="magenta font-weight-bold"> one offer per line </span> on your account</p>
                {keepAndSwithOffer && <div>
                    <a href={buildOfferRedirectHref(keepAndSwitchRedirectBase, switch2Url, "KS-", keepAndSwithOffer.offerId, inputPhoneNumber)}>{keepAndSwithOffer.description}</a>
                </div>}
                {cfOffer && <div>
                    <a href={buildOfferRedirectHref(carrierFreedomRedirectBase, switch2Url, "FamilyFreedom-", cfOffer.offerId, inputPhoneNumber)}>{cfOffer.description}</a>
                </div>}
                {hintOffer && <div>
                    <a href={switch2Url + "HintFreedom-" + hintOffer.offerId + "-" + inputPhoneNumber}>{hintOffer.description}</a>
                </div>} 
                {promoOffers.length > 0 &&  promoOffers.map((offer) =><div >
                <Link  to="#0" onClick={() => setCampaign(offer.promoCode)} key={offer.offerId}>{offer.description}</Link>
                </div>)}
                {transactionChannel === "4" &&
                    <div>
                        <p>Great News! You also qualify for the Costco Member Benefit promotion in addition to one of these great offers. Visit <Link  to="#0" onClick={() => setCampaign(costco)} key={costco}>promotions.t-mobile.com/costco</Link> to submit for this offer.</p>
                    </div>
                }
                {transactionChannel === "5" &&
                    <div>
                        <p>Great News! You also qualify for the Sam’s Club Member Benefit promotion in addition to one of these great offers. Visit <Link  to="#0" onClick={() => setCampaign(samsclub)} key={samsclub}>promotions.t-mobile.com/samsclub</Link> to submit for this offer.</p>
                    </div>
                }
            </div>
            {!isSubmitting && errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}

        </>
    )
}

FrontDoorOffersSection.propTypes = {
    offerList: PropTypes.array,
    history: PropTypes.object.isRequired,
    transactionChannel: PropTypes.string,
    inputPhoneNumber: PropTypes.string.isRequired,
    isTfbOrBau: PropTypes.bool
}